/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paywall_Content_ZoneInputs */

const en_paywall_content_zone = /** @type {(inputs: Paywall_Content_ZoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paywall Content Zone`)
};

const es_paywall_content_zone = /** @type {(inputs: Paywall_Content_ZoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zona de contenido de pago`)
};

const fr_paywall_content_zone = /** @type {(inputs: Paywall_Content_ZoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zone de contenu avec paywall`)
};

const de_paywall_content_zone = /** @type {(inputs: Paywall_Content_ZoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paywall-Content-Zone`)
};

const ja_paywall_content_zone = /** @type {(inputs: Paywall_Content_ZoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ペイウォールコンテンツゾーン`)
};

const zh_paywall_content_zone = /** @type {(inputs: Paywall_Content_ZoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`付费内容专区`)
};

const ar_paywall_content_zone = /** @type {(inputs: Paywall_Content_ZoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منطقة المحتوى المدفوع`)
};

const id_paywall_content_zone = /** @type {(inputs: Paywall_Content_ZoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zona Konten Berbayar (Paywall)`)
};

const it_paywall_content_zone = /** @type {(inputs: Paywall_Content_ZoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zona Contenuti a Pagamento`)
};

const ru_paywall_content_zone = /** @type {(inputs: Paywall_Content_ZoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платная зона контента`)
};

const pt_paywall_content_zone = /** @type {(inputs: Paywall_Content_ZoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zona de Conteúdo com Paywall`)
};

const ko_paywall_content_zone = /** @type {(inputs: Paywall_Content_ZoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`페이월 콘텐츠 구역`)
};

/**
* | output |
* | --- |
* | "Paywall Content Zone" |
*
* @param {Paywall_Content_ZoneInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const paywall_content_zone = /** @type {((inputs?: Paywall_Content_ZoneInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paywall_Content_ZoneInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_paywall_content_zone(inputs)
	if (locale === "es") return es_paywall_content_zone(inputs)
	if (locale === "fr") return fr_paywall_content_zone(inputs)
	if (locale === "de") return de_paywall_content_zone(inputs)
	if (locale === "ja") return ja_paywall_content_zone(inputs)
	if (locale === "zh") return zh_paywall_content_zone(inputs)
	if (locale === "ar") return ar_paywall_content_zone(inputs)
	if (locale === "id") return id_paywall_content_zone(inputs)
	if (locale === "it") return it_paywall_content_zone(inputs)
	if (locale === "ru") return ru_paywall_content_zone(inputs)
	if (locale === "pt") return pt_paywall_content_zone(inputs)
	return ko_paywall_content_zone(inputs)
});